<template lang="pug">
    #companion-view-plan
       BLoading(:active="viewPlanLoading" :is-full-page="true")
       .companion-view-plan-content(v-if="!viewPlanLoading")
            .companion-action-menu
                CompanionActionsMenu(:backButton="goBack")
            .edit-plan-container
                p.title Your plan
                WtButton.edit-button(isRouterLink size="medium" :to="{ name: 'Assessment' }")
                    WtSvgIcon(icon="companion/worksheet" width="19px" height="19px").mt-1
                    | Edit plan
            .user-plan-container
                div(v-for="(Answer, index) in viewPlan" :key="index")
                    p.answer-title {{ Answer.Text }}
                        div(v-for="(strategy, index) in Answer.RelatedStrategies" :key="strategy.Id")
                            .right-arrow-card
                                CompanionRightArrowCard(:redirectTo="getStrategyRedirectUrl(strategy.Id)" :title="strategy.Title" )
   </template>
<script>
import WtButton from "@@/WtButton/WtButton.vue";
import WtTitle from "@@/WtTitle/WtTitle.vue";
import WtTile from "@@/WtTile/WtTile";
import { mapActions } from "vuex";
import CompanionActionsMenu from "@@/Companion/CompanionActionsMenu";
import CompanionRightArrowCard from "@@/Companion/CompanionRightArrowCard";
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon";

export default {
  name: "CompanionViewPlan",
  components: {
    WtButton,
    WtTitle,
    WtTile,
    CompanionActionsMenu,
    CompanionRightArrowCard,
    WtSvgIcon
  },
  data() {
    return {
      viewPlanLoading: false,
      viewPlan: {}
    };
  },
  computed: {},
  async mounted() {
    try {
      this.viewPlanLoading = true;
      let response = {};
      if (
        Object.keys(response).length === 0 ||
        Object.keys(response.data).length === 0
      ) {
        response = await this.fetchUserPlan();
      }
      this.viewPlanLoading = false;
      this.viewPlan = response.data.Answers;
    } catch (e) {
      this.viewPlanLoading = false;
      this.snackBar({
        duration: 5000,
        type: "is-danger",
        message: e.message
      });
    }
  },
  methods: {
    ...mapActions("companion", ["fetchUserPlan"]),
    ...mapActions(["snackBar"]),

    goBack() {
      window.history.back();
    },

    getStrategyRedirectUrl(strategyId) {
      return `/plan/strategy/${strategyId}`;
    }
  }
};
</script>
<style scoped>
#companion-view-plan {
  width: 100% !important;
  margin: 0 auto;
}

.companion-view-plan-content {
  border-radius: 16px;
  font-weight: 60 !important;
  line-height: 30px;
  font-size: 1.3rem;
  padding: 0px;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.companion-action-menu {
  width: 700px;
}

.user-plan-container {
  width: 700px;
}

.title {
  color: var(--Text-General-Primary, #1b1d20);
  font-family: Manrope;
  font-size: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  margin: 0rem;
}

.edit-plan-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 700px;
  padding: 24px 0px 1px 1px;
  margin: 0px !important;
}

.answer-title {
  color: #1b1d20;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  padding: 24px 0px 2px 0px;
}

.right-arrow-card {
  padding-top: 10px;
}

.edit-button {
  display: inline-flex;
  padding: 6px 8px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-radius: 6px;
  background: #2972f0;
  color: #ffffff;
  text-align: center;
  font-family: Manrope;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
}

@media screen and (max-width: 768px) {
  #companion-daily-content {
    max-width: 80%;
  }
  .user-plan-container {
    width: 100%;
    height: min-content;
  }
  .title {
    width: 100%;
  }
  .edit-plan-container {
    width: 100%;
  }
  .companion-action-menu {
    width: 100%;
  }
}

@media screen and (max-width: 480px) {
  #companion-daily-content {
    max-width: 100%;
  }
  .edit-plan-container {
    width: 100%;
  }
  .companion-action-menu {
    width: 100%;
  }
}
</style>
